export const USER_PREFERENCES = 'USER_PREFERENCES';
export const USER_UPDATED_HEADER = 'X-User-Updated';
